export default {
  RESET_ADD_REPORT_STATE: 'RESET_ADD_REPORT_STATE',
  SET_ADD_REPORT_IS_LOADING: 'SET_ADD_REPORT_IS_LOADING',
};
